import { BrowserRouter, Routes, Route } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { RootState } from "./redux/store";
import { setLanguage } from "./redux/slices/languageSlice";
import Services from "./pages/Services/Services";
import Products from "./pages/Products/Products";
import Maintenance from "./pages/Maintenance/Maintenance";
import Partners from "./pages/Partners/Partners";
import StartPage from "./pages/Start/Start";
import Footer from "./pages/components/footer/footer";
import Policy from "./pages/Policy/Policy";
import Header from "./pages/components/header/Header";
import Solutions from "./pages/Solutions/Solutions";
import TestDrivePage from "./pages/TestDrive/TestDrive";
import { useEffect } from "react";
import { useTranslation } from "react-i18next";
import "./i18n";

const App: React.FC = () => {
  const dispatch = useDispatch();
  const currentLanguage = useSelector((state: RootState) => state.language.language);
  const { i18n } = useTranslation(); 

  const changeLanguage = (lang: string) => {
    dispatch(setLanguage(lang));
  };

  useEffect(() => {
    i18n.changeLanguage(currentLanguage); 
  }, [currentLanguage, i18n]);

  return (
    <BrowserRouter>
      <Header />
      <Routes>
        <Route path="/services" element={<Services />} />
        <Route path="/solutions" element={<Solutions />} />
        <Route path="/products" element={<Products />} />
        <Route path="/partners" element={<Partners />} />
        <Route path="/policy" element={<Policy />} />
        <Route path="/test-drive" element={<TestDrivePage />} />
        <Route path="/" element={<StartPage />} />
      </Routes>
      <Footer />
    </BrowserRouter>
  );
};

export default App;
